<template>
  <div class="addModel model">
    <div class="photoArea" v-if="type !== 'vertifyorder'">
      <el-row>
        <div class="element-list jb-bg">仪器照片</div>
      </el-row>
      <el-row>
       
        <div class="yq-img">
          <el-upload
            class="avatar-uploade"
            :action="uploadUrl"
            :http-request="myupload"
            :show-file-list="false"
            :accept="'image/*'"
            :before-upload="handleBeforeUpload"
          >
            <img v-if="imgURL" :src="imgURL" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <span
              v-if="imgURL"
              class="delect-icon"
              style="
                position: absolute;
                top: 0;
                right: 25px;
                background-color: rgba(0, 0, 0, 0.5);
                color: #fff;
              "
              @click.stop="removeImg"
            >
              <i class="el-icon-delete" style="font-size: 16px"></i>
            </span>
          </el-upload>
        </div>
      </el-row>
    </div>
   
    <div class="detailed bar">
      <template v-if="type === 'add'">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="left-item jb-bg file-style-item1" @click="copy" style="cursor: pointer">
              复制仪器
            </div>
            <el-dialog
              class="popout"
              width="1200px"
              title="复制仪器"
              :visible.sync="copyVisible"
              v-if="copyVisible"
              append-to-body
              center
            >
              <copyIns @choosedcopy="choosedcopy" @cancel="copyCancel"></copyIns>
            </el-dialog>
          </el-col>
        </el-row>
      </template>
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">仪器名称</div>
            <div class="rigth-item">
              <el-input placeholder  maxlength="50"  v-model="formData.instrumentName"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">仪器编号</div>
            <div class="rigth-item">
              <el-input placeholder maxlength="30"  v-model="formData.serialNumber"></el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">生产厂商</div>
            <div class="rigth-item">
              <el-input placeholder maxlength="50"  v-model="formData.factoryName"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">出厂编号</div>
            <div class="rigth-item">
              <el-input placeholder maxlength="30"  v-model="formData.factoryNumber"></el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">型号</div>
            <div class="rigth-item">
              <el-input placeholder maxlength="30"  v-model="formData.pattern"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">量程</div>
            <div class="rigth-item">
              <el-input placeholder maxlength="100" 
              v-model="formData.range"></el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">精度</div>
            <div class="rigth-item">
              <el-input placeholder  maxlength="100" 
              v-model="formData.precision"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">检定/校准机构</div>
            <div class="rigth-item">
              <el-input placeholder maxlength="30"  v-model="formData.calibrationMechanism"></el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">不确定度/准确度</div>
            <div class="rigth-item">
              <el-input maxlength="100"  placeholder v-model="formData.accuracy"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">检定/校准周期</div>
            <div class="rigth-item">
              <el-input placeholder maxlength="30"  v-model="formData.validityPeriod"></el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">保养周期</div>
            <div class="rigth-item">
              <el-input placeholder maxlength="30"  v-model="formData.maintenancePeriod"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">检定/校准有效期</div>
            <div class="rigth-item">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="formData.validityEffectiveTime"
                type="datetime"
                placeholder="选择日期"
              ></el-date-picker>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">保养有效期</div>
            <div class="rigth-item">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="formData.maintenanceEffectiveTime"
                type="datetime"
                placeholder="选择日期"
              ></el-date-picker>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">上次保养时间</div>
            <div class="rigth-item">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="formData.lastMaintenanceTime"
                type="datetime"
                placeholder="上次保养时间"
              ></el-date-picker>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="12">
          <div class="row-item element-list my-tetxt">
            <div class="left-item jb-bg">充电型设备</div>
            <div class="rigth-item">
              <el-select
                :poper-append-to-body="false"
                popper-class="my-select"
                v-model="formData.isCharger"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">上次检定时间</div>
            <div class="rigth-item">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="formData.lastCalibrationTime"
                type="datetime"
                placeholder="上次检定时间"
              ></el-date-picker>
            </div>
          </div>
        </el-col>
      </el-row>
<!--      <template v-if="type === 'add'">-->
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">价钱</div>
            <div class="rigth-item">
              <el-input placeholder maxlength="10"
              @input="formData.prize = formData.prize.replace(/[^\d|\.]/g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                v-model="formData.prize"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">出厂日期</div>
            <div class="rigth-item">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="formData.produceTime"
                type="datetime"
                placeholder="出厂日期"
              ></el-date-picker>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">购买日期</div>
            <div class="rigth-item">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="formData.purchaseTime"
                type="datetime"
                placeholder="购买日期"
              ></el-date-picker>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list my-tetxt" v-if="yqVal!=3">
            <div class="left-item jb-bg">是否审批</div>
            <div class="rigth-item">
              <el-select
                :poper-append-to-body="false"
                popper-class="my-select"
                v-model="formData.isNeedApprove"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isNeedApproveList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        
      </el-row>
       <el-row :gutter="20">
        
        <el-col :span="12">
          <div class="row-item element-list my-tetxt" :class="{'is-disabled-wrap': isDepotDisabled}">
            <div class="left-item jb-bg">所属仓库</div>
            <div class="rigth-item">
              <el-select
                :poper-append-to-body="false"
                popper-class="my-select"
                v-model="formData.depotId"
                :disabled="isDepotDisabled"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in depotList"
                  :key="item.id"
                  :label="item.depotName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-item element-list">
            <div class="left-item jb-bg">存放位置</div>
            <el-input maxlength="100"  placeholder v-model="formData.address"></el-input>
          </div>
        </el-col>
        
      </el-row>
      <el-row :gutter="20">
     
        <el-col :span="12">
          <div class="row-item element-list my-tetxt" >
            <div class="left-item jb-bg">资产类型</div>
            <div class="rigth-item">
              <el-select
                :poper-append-to-body="false"
                popper-class="my-select"
                v-model="formData.assetType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in [
                    {label:'固定资产',value:1},
                    {label:'非固定资产',value:2},
                    ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
         <el-col :span="12">
          <div class="row-item element-list my-tetxt">
            <div class="left-item jb-bg">红外检测</div>
            <div class="rigth-item">
              <el-select
                :poper-append-to-body="false"
                popper-class="my-select"
                v-model="formData.checkInCabinet"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in [
                    {label:'是',value:1},
                    {label:'否',value:0},
                    ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-tooltip content="选择‘是’，红外感应器将检测格口内是否有仪器" placement="top">
                <i class="el-icon-warning" style="    position: relative;
    left: -220px;color: #e6a23c; font-size: 14px; cursor: pointer; margin-left: 4px;"></i>
              </el-tooltip>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="row-item element-list my-tetxt" v-if="yqVal==''">
            <div class="left-item jb-bg">仪器类型</div>
            <div class="rigth-item">
              <el-select
                :poper-append-to-body="false"
                popper-class="my-select"
                v-model="deviceType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in [
                    {label:'普通仪器',value:1},
                    {label:'仪器组',value:2},
                    {label:'固定式仪器',value:3},
                    ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
       
      </el-row>
<!--      </template>-->
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="24">
          <div class="left-item jb-bg file-style-item1" @click="fileChange" style="cursor: pointer">
            附属文件上传
          </div>
          <el-dialog
            class="popout"
            width="448px"
            title="文件上传弹框"
            :visible.sync="innerVisible"
            v-if="innerVisible"
            append-to-body
            center
          >
            <myFiles @fileChange="onChange" @cancel="fileCancel"></myFiles>
          </el-dialog>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="(type !== 'vertifyorder') && (fileList.length > 0)">
        <el-col :span="24">
          <div class="filesupload">
            <ul class="el-upload-list el-upload-list--text">
              <li
                tabindex="0"
                class="el-upload-list__item is-success"
                v-for="(item, index) in fileList"
                :key="index"
              >
                <a class="el-upload-list__item-name">
                  <i class="el-icon-document"></i>
                  <i class="fileName">{{ item.fileName }}</i>
                  <i class="typeName">{{ item.typeName }}</i>
                </a>
                <label class="el-upload-list__item-status-label">
                  <i class="el-icon-upload-success el-icon-circle-check"></i>
                </label>
                <i class="el-icon-close" @click="removeFile(item)"></i>
                <i class="el-icon-close-tip">按 delete 键可删除</i>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type !== 'vertifyorder'">
        <el-col :span="24">
          <el-input
            type="textarea"
            :rows="2"
            maxlength="200"
            v-model="formData.requirements"
            placeholder="检定要求"
          ></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="isOpenVerify">
        <el-col :span="24">
          <div class="left-item jb-bg file-style-item1" @click="addCheckCon" style="cursor: pointer">
            增加检定要求
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="isOpenVerify">
        <el-col :span="24">
          <div class="checkCons">
            <div class="checkCon" v-for="(item, index) in checkCon" :key="index">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="row-item element-list">
                    <div class="left-item jb-bg">参数名称</div>
                    <div class="rigth-item">
                      <el-input placeholder maxlength="30"  v-model="item.paramName" @input="(val) => changeParamName(val, index)"></el-input>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="row-item element-list">
                    <div class="left-item jb-bg">量程(最大范围）</div>
                   
                    <div class="rigth-item">
                      <el-input placeholder="值" maxlength="10" @input="item.minRange = item.minRange.replace(/[^\d|\.]/g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"  v-model="item.minRange"></el-input>
                      ~
                      <el-input placeholder="值" maxlength="10" @input="item.maxRange = item.maxRange.replace(/[^\d|\.]/g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"    v-model="item.maxRange"></el-input>
                      <el-input placeholder="单位" maxlength="10" v-model="item.rangeUnit"></el-input>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="row-item element-list">
                    <div class="left-item jb-bg">最小不确定度/准确度</div>
                    <div class="rigth-item">
                      <el-input placeholder="值" maxlength="10" @input="item.accuracy = item.accuracy.replace(/[^\d|\.]/g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')" v-model="item.accuracy"></el-input>
                      <el-input placeholder="单位" maxlength="10" v-model="item.accuracyUnit"></el-input>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="row-item element-list">
                    <div class="left-item jb-bg">最小精度</div>
                    <div class="rigth-item">
                      <el-input placeholder="值" maxlength="10" @input="item.precision = item.precision.replace(/[^\d|\.]/g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                        v-model="item.precision"></el-input>
                      <el-input placeholder="单位" maxlength="10" v-model="item.precisionUnit"></el-input>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <i class="el-icon-circle-close closeIcon" @click="deleteCheckCon(index)"></i>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="isOpenVerify">
        <el-col :span="24">
          <div class="left-item jb-bg file-style-item1" @click="chooseStandard" style="cursor: pointer">
            选择规范
          </div>
          <el-dialog
            class="popout"
            width="1200px"
            title="选择规范"
            :visible.sync="chooseStandardVisible"
            v-if="chooseStandardVisible"
            append-to-body
            center
          >
            <chooseStandard @choosed="choosed" @cancel="chooseStandardCancel"></chooseStandard>
          </el-dialog>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="isOpenVerify">
        <el-col :span="24">
          <div class="standards">
            <div class="standard" v-for="(item, index) in standardList" :key="index">
              <el-row :gutter="20">
                <el-col :span="24">
                  规范：{{ item.standardName }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  编号：{{ item.standardCode }}
                </el-col>
                <el-col :span="12">
                  版本号：{{ item.version }}
                </el-col>
              </el-row>
              <div v-for="(ct, ci) in item.checkParams" :key="ci">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="row-item element-list">
                      <div class="left-item jb-bg">参数名称</div>
                      <div class="rigth-item">
                        <el-input placeholder maxlength="100" v-model="ct.paramName"></el-input>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="row-item element-list">
                      <div class="left-item jb-bg">量程(最大范围）</div>
                      <div class="rigth-item">
                        <el-input placeholder="值"  @input="ct.minRange = ct.minRange.replace(/[^\d|\.]/g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                         maxlength="10"  v-model="ct.minRange"></el-input>
                        ~
                        <el-input placeholder="值" maxlength="10"  @input="ct.maxRange = ct.maxRange.replace(/[^\d|\.]/g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                         v-model="ct.maxRange"></el-input>
                        <el-input placeholder="单位"  maxlength="10" v-model="ct.rangeUnit"></el-input>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="row-item element-list">
                      <div class="left-item jb-bg">最小不确定度/准确度</div>
                      <div class="rigth-item">
                        <el-input placeholder="值"  maxlength="10"  @input="ct.accuracy = ct.accuracy.replace(/[^\d|\.]/g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                         v-model="ct.accuracy"></el-input>
                        <el-input placeholder="单位"  maxlength="10" v-model="ct.accuracyUnit"></el-input>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="row-item element-list">
                      <div class="left-item jb-bg">最小精度</div>
                      <div class="rigth-item">
                        <el-input placeholder="值" maxlength="10"  @input="ct.precision = ct.precision.replace(/[^\d|\.]/g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                         v-model="ct.precision"></el-input>
                        <el-input placeholder="单位" maxlength="10" v-model="ct.precisionUnit"></el-input>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type === 'vertifyorder'">
        <el-col :span="24">
          <div class="left-item jb-bg file-style-item1" style="cursor: pointer">
            报告结果截图上传
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type === 'vertifyorder'">
        <el-col :span="24">
          <el-upload
            class="resultPic-uploade"
            :action="uploadUrl"
            :http-request="myuploadResultPic"
            :show-file-list="false"
            :accept="'image/*'"
          >
            <img v-if="resultPicFileURL" :src="resultPicFileURL" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <span
              v-if="resultPicFileURL"
              class="delect-icon"
              style="
                position: absolute;
                top: 10px;
                right: 10px;
                background-color: rgba(0, 0, 0, 0.5);
                color: #fff;
              "
              @click.stop="removeResultPicImg"
            >
              <i class="el-icon-delete" style="font-size: 16px"></i>
            </span>
          </el-upload>
        </el-col>
      </el-row>
     
      <div class="footer">
        <div class="jb-bg btn" @click="submitFiles">确认</div>
        <div class="btn" @click="cancel">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { deleteFile, FileUrl, getDepotInfo } from "@/api/depotApi";
import axios from '@/util/request';
import { GetInstrument } from "@/api/VertifyOrder";
import { mapState } from "vuex";
import myFiles from "../files";
import chooseStandard from "@/components/chooseStandard";
import copyIns from "@/components/copyIns";
export default {
  props: {
    itemData: Object,
    type: String,
  },
  data() {
    return {
      options: [
        {
          value: true,
          label: "是",
        },
        {
          value: false,
          label: "否",
        },
      ],
      isNeedApproveList: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      innerVisible: false,
      chooseStandardVisible: false,
      copyVisible: false,
      deviceType:null,
      uploadUrl: "/admin/sys-file/upload", //上传地址
      formData: {
        id: "", //编辑的id
        depotId: "", //选中仓库
        deptId: "", //选中单位
        deviceType: "", //是仪器还是仪器组还是固定仪器
        isNeedApprove:0,
        photoUrl: "",
        assetType:'',
        checkInCabinet:'',

        instrumentName: "", //仪器名称
        serialNumber: "", //仪器编号
        factoryName: "", //生产厂商
        factoryNumber: "", //出厂编号
        pattern: "", //型号
        range: "", //量程
        precision: "", //精度
        calibrationMechanism: "", //检定/校准机构
        accuracy: "", //不确定/准确度
        validityPeriod: "", //检定/校准周期
        maintenancePeriod: "", //保养周期
        validityEffectiveTime: "", //检定/校准有效期
        maintenanceEffectiveTime: "", ////保养有效期
        lastMaintenanceTime: "", //上次保养时间
        isCharger: false, //充电型设备
        lastCalibrationTime: "", //上次检定时间
        prize: "",//价钱
        produceTime: "",//出厂日期
        purchaseTime: "",//购买日期
        address: "",//存放位置 
        requirements: "", //检定要求
      },
      fileList: [], //文件临时存放列表
      checkCon: [],
      standardList: [],
      resultPicFile: '',
      imgURL: '',
      resultPicFileURL: '',
      depotList: [],
      isOpenVerify: false,
    };
  },
  created() {
    if (this.itemData) {
      this.deviceType = this.itemData.deviceType
      if (this.itemData.checkParams && this.itemData.checkParams.length > 0) {
        this.itemData.checkParams.forEach(item => {
          this.checkCon.push(item);
        })
      }
      if (this.itemData.standards && this.itemData.standards.length > 0) {
        this.itemData.standards.forEach(item => {
          this.standardList.push(item);
        });
      }
    }
    this.isOpenVerify = this.$store.state.user.modulePower.openVerify;
    this.getDepotList();
    this.formData.depotId = this.DepotId;
  },
  components: {
    myFiles,
    chooseStandard,
    copyIns,
  },
  computed: {
    ...mapState(["depot"]),
    yqVal() {
      //判断是仪器还是仪器组还是固定仪器
      return this.depot.yqtype;
    },
    DepotId() {
      //选中仓库
      return this.depot.selectWarehouse;
    },
    deptId() {
      //选中单位
      return Number(this.$store.state.user.userInfo.deptId);
    },
    isDepotDisabled() {
      return this.itemData && this.itemData.boxIndex !== null && this.itemData.boxIndex !== undefined && this.itemData.boxIndex !== '';
    },
  },
  watch: {
    checkCon: {
      handler(newval) {
        var s = this.standardList.map((item) => {
          let cp = [];
          for (let i = 0; i < newval.length; i++) {
            cp.push({
              paramName: newval[i].paramName,
              minRange: newval[i].minRange,
              maxRange: newval[i].maxRange,
              rangeUnit: newval[i].rangeUnit,
              accuracy: newval[i].accuracy,
              accuracyUnit: newval[i].accuracyUnit,
              precision: newval[i].precision,
              precisionUnit: newval[i].precisionUnit,
            });
          }
          return {
            ...item,
            checkParams: cp,
          };
        });
        this.standardList = s;
      },
      deep: true,
    }
  },
  mounted() {
    if (this.itemData) {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = this.itemData[key];
        if (
          key == "validityEffectiveTime" ||
          key == "maintenanceEffectiveTime" ||
          key == "lastMaintenanceTime" ||
          key == "lastCalibrationTime"
        ) {
          if (this.formData[key]) {
            this.formData[key] = this.formData[key].replace(/T/g, " ");
          }
        }
      });
      this.imgURL = this.itemData.photoLink;
      this.fileList = this.itemData.files || [];
    }
  },
  methods: {
    getDepotList() {
      getDepotInfo({ deptId: this.deptId }).then((res) => {
        if (res.code == "200") {
          this.depotList = res.data;
        }
      });
    },
    // 文件上传弹框
    fileChange() {
      this.innerVisible = true;
    },
    onChange(data) {
      this.fileList.push(data);
      this.innerVisible = false;
    },
    fileCancel() {
      this.innerVisible = false;
    },
    myupload(item) {
      let that = this;
      let fileObj = item.file;
      const form = new FormData();
      form.append("file", fileObj);
      axios({
        url: item.action,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: form
      }).then(res => {
        if (res.succeed) {
          // that.formData.photoUrl = res.data[0];
          that.formData.photoUrl = res.data.fileName;
          FileUrl({ objectName: res.data.fileName }).then((res) => {
            that.imgURL = res.data;
          });
        }
        else {
          that.$message.error(res.msg);
        }
      }).catch((data) => {
        that.$message.error("上传失败,请重新上传图片!");
      });
    },
    handleBeforeUpload(file) {
      const isImage = file.type.includes("image");
      if (!isImage) {
        this.$message.error("上传文件类型必须是图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isImage && isLt2M;
    },
    removeImg() {
      this.imgURL = "";
      this.formData.photoUrl = "";
    },
    removeFile(file) {
      for (let i = this.fileList.length - 1; i >= 0; i--) {
        if (this.fileList[i].filePath == file.filePath) {
          if (this.fileList[i].id) {
            deleteFile({ fileId: this.fileList[i].id }).then((res) => {

            });
          }
          this.fileList.splice(i, 1);
        }
      }
    },
    submitFiles() {
      if (this.formData.instrumentName == "" || this.formData.instrumentName == null) {
        this.$message.warning("仪器名称不能为空");
        return;
      }
      if (this.formData.serialNumber == "" || this.formData.serialNumber == null) {
        this.$message.warning("仪器编号不能为空");
        return;
      }
     
      if (this.yqVal == "" &&!this.deviceType) {
        this.$message.warning("仪器类型不能为空 ");
        return;
      }
    
      // if (this.yqVal!=3&&this.formData.isNeedApprove == "") {
      //   console.log(this.formData.isNeedApprove)
      //   this.$message.warning("请选择是否需要审批");
      //   return;
      // }
      if(this.checkCon.length){
        for (let index = 0; index < this.checkCon.length; index++) {
          const element = this.checkCon[index];
          if(!element.paramName){
            this.$message.warning("参数名称不能为空");
            return;
          }
          
        }

      }
      let data = {
        newUploadFile: this.fileList,
        standards: this.standardList,
        checkParams: this.checkCon,
        resultPicFile: this.resultPicFile,
        ...this.formData,
        serialNumber:this.formData.serialNumber.replace(/\s+/g, ''),
        deviceType: this.yqVal?this.yqVal:this.deviceType,
        deptId: this.deptId,
      };
      this.$emit("operation", data);
      this.$emit("editingInstrument", data);
    },
    cancel() {
      this.$emit("cancel");
      this.$emit("editingInstrument", "cancel");
    },
    addCheckCon() {
      let length = this.checkCon.length;
      this.checkCon.push({
        paramName: '',
        minRange: '',
        maxRange: '',
        rangeUnit: '',
        accuracy: '',
        accuracyUnit: '',
        precision: '',
        precisionUnit: '',
      });
      this.standardList.forEach((item, index) => {
        item.checkParams.splice(length, 0, {
          paramName: '',
          minRange: '',
          maxRange: '',
          rangeUnit: '',
          accuracy: '',
          accuracyUnit: '',
          precision: '',
          precisionUnit: '',
        })
      });
    },
    deleteCheckCon(index) {
      this.checkCon.splice(index, 1);
      this.standardList.forEach((item) => {
        item.checkParams.splice(index, 1);
      });
    },
    chooseStandard() {
      this.chooseStandardVisible = true;
    },
    chooseStandardCancel() {
      this.chooseStandardVisible = false;
    },
    choosed(selection) {
      this.standardList = [];
      selection.forEach((item) => {
        let cp = [];
        this.checkCon.forEach(cpit => {
          cp.push({
            paramName: cpit.paramName,
            minRange: cpit.minRange,
            maxRange: cpit.maxRange,
            rangeUnit: cpit.rangeUnit,
            accuracy: cpit.accuracy,
            accuracyUnit: cpit.accuracyUnit,
            precision: cpit.precision,
            precisionUnit: cpit.precisionUnit,
          })
        })
        this.standardList.push({
          standardName: item.standardName,
          standardCode: item.standardCode,
          version: item.version,
          fileName: item.fileName,
          filePath: item.filePath,
          deptId: item.deptId,
          createUser: item.createUser,
          createUserName: item.createUserName,
          createTime: item.createTime,
          updateTime: item.updateTime,
          instrumentId: item.instrumentId,
          standardId: item.id,
          checkParams: cp,
        });
      })
      this.chooseStandardVisible = false;
    },
    changeParamName(val, index) {
      this.standardList.forEach(item => {
        item.checkParams[index].paramName = val;
      });
    },
    myuploadResultPic(item) {
      let that = this;
      let fileObj = item.file;
      const form = new FormData();
      form.append("file", fileObj);
      axios({
        url: item.action,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: form
      }).then(res => {
        if (res.succeed) {
          // that.resultPicFile = res.data[0];
          that.resultPicFile = res.data.fileName;
          FileUrl({ objectName: res.data.fileName }).then((res) => {
            that.resultPicFileURL = res.data;
          });
        }
        else {
          if (res.code === '401') {
            that.$message.error('登录过期，请重新登录！');
            setTimeout(()=>{
              window.sessionStorage.clear();
              window.localStorage.clear();
              window.location.href= "/login";
            },1000);
            that.$message.destroyed();
            return false;
          }
          else {
            that.$message.error(res.msg);
          }
        }
      }).catch((data) => {
        that.$message.error("上传失败,请重新上传图片!");
      });
    },
    removeResultPicImg() {
      this.resultPicFile = "";
      this.resultPicFileURL = "";
    },
    copy() {
      this.copyVisible = true;
    },
    copyCancel() {
      this.copyVisible = false;
    },
    choosedcopy(selection) {
      let self = this;
      if (selection.length > 0) {
        let data = selection[0];
        GetInstrument(data.id).then(res => {
          let particular = res.data;
          Object.keys(self.formData).forEach((key) => {
            if (key !== 'id' && key !== 'depotId' && key !== 'deptId' && key !== 'deviceType' && key !== 'serialNumber' && key !== 'factoryNumber') {
              self.formData[key] = particular[key];
              if (
                key == "validityEffectiveTime" ||
                key == "maintenanceEffectiveTime" ||
                key == "lastMaintenanceTime" ||
                key == "lastCalibrationTime"
              ) {
                if (this.formData[key]) {
                  this.formData[key] = this.formData[key].replace(/T/g, " ");
                }
              }
            }
          });
          self.imgURL = particular.photoLink;
          self.fileList = particular.files || [];
          if (particular.checkParams && particular.checkParams.length > 0) {
            particular.checkParams.forEach(item => {
              let ni = {
                paramName: item.paramName,
                minRange: item.minRange,
                maxRange: item.maxRange,
                rangeUnit: item.rangeUnit,
                accuracy: item.accuracy,
                accuracyUnit: item.accuracyUnit,
                precision: item.precision,
                precisionUnit: item.precisionUnit,
              }
              self.checkCon.push(ni);
            })
          }
          if (particular.standards && particular.standards.length > 0) {
            particular.standards.forEach(item => {
              let cp = [];
              item.checkParams.forEach(ic => {
                let ni = {
                  paramName: ic.paramName,
                  minRange: ic.minRange,
                  maxRange: ic.maxRange,
                  rangeUnit: ic.rangeUnit,
                  accuracy: ic.accuracy,
                  accuracyUnit: ic.accuracyUnit,
                  precision: ic.precision,
                  precisionUnit: ic.precisionUnit,
                }
                cp.push(ni);
              })
              let ns = {
                standardName: item.standardName,
                standardCode: item.standardCode,
                version: item.version,
                fileName: item.fileName,
                filePath: item.filePath,
                deptId: item.deptId,
                createUser: item.createUser,
                createUserName: item.createUserName,
                createTime: item.createTime,
                updateTime: item.updateTime,
                instrumentId: item.instrumentId,
                standardId: item.standardId,
                checkParams: cp,
              }
              self.standardList.push(ns);
            });
          }
        });
      }
      self.copyVisible = false;
      self.$nextTick(() => {
        self.formData = Object.assign({},self.formData)
      })
    },
  },
};
</script>

<style lang='less' scoped>
.addModel {
  width: 100%;
  color: #74c8fe;
  display: flex;
  .photoArea {
    width: 178px;
    .yq-img {
      .avatar-uploader .el-upload {
        border: 2px solid #0090F0;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #74c8fe;
        width: 178px;
        height: 178px;
        border: 2px solid #0090F0;
        border-radius: 6px;
        line-height: 178px;
        text-align: center;
        box-sizing: border-box;
      }
      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
    }
  }
  .detailed {
    overflow-y: auto;
    padding: 0 25px;
    height: 600px;
    flex: 1;
    .filesupload {
      border: 2px solid #0090f0;
      border-radius: 6px;
      margin: 10px 0;
      .el-upload-list {
        width: 100%;
      }
      .el-upload-list__item:first-child {
        margin-top: 5px;
      }
      .el-upload-list__item {
        margin: 5px 0;
      }
      .el-upload-list__item-name {
        height: 26px;
        line-height: 26px;
        display: flex;
      }
      .fileName {
        width: 380px;
        height: 100%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .typeName {
        width: 150px;
        height: 100%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .checkCons {
      border: 2px solid #0090f0;
      border-radius: 6px;
      margin: 10px 0;
      padding: 0 10px;
      min-height: 50px;
      .checkCon {
        border: 2px solid #0090f0;
        border-radius: 6px;
        margin: 10px 0;
        padding: 18px 15px 0 15px;
        position: relative;
        .closeIcon {
          position: absolute;
          top: 4px;
          right: 4px;
          font-size: 18px;
          color: #0090f0;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
    .standards {
      border: 2px solid #0090f0;
      border-radius: 6px;
      margin: 10px 0;
      padding: 0 10px;
      min-height: 50px;
      .standard {
        border: 2px solid #0090f0;
        border-radius: 6px;
        margin: 10px 0;
        padding: 18px 15px 10px 15px;
        position: relative;
      }
    }
    .files {
      border: 2px solid #0090f0;
      border-radius: 6px;
      margin: 10px 0;
      padding: 0 10px;
    }
    .resultPic-uploade {
      /deep/ .el-upload {
        position: relative;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #74c8fe;
        width: 178px;
        height: 178px;
        border: 2px solid #0090F0;
        border-radius: 6px;
        line-height: 178px;
        text-align: center;
        box-sizing: border-box;
      }
      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
    }
    .row-item {
      display: flex;
      .left-item {
        width: 150px;
      }
      .rigth-item {
        flex: 1;
        display: flex;
        /deep/ .el-input {
          flex: 1;
          border-right: 2px solid #0090f0;
          &:last-child {
            border-right: 0;
          }
          &:first-child {
            border-right: 0;
          }
        }
        /deep/ .el-input__prefix {
          display: none;
        }
        /deep/ .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }
        /deep/ .el-input__icon {
          line-height: 30px;
        }
        /deep/ .el-input.is-disabled .el-input__inner {
          background-color: transparent !important;
          border-color: #0090f0 !important;
          color: #666 !important;
          cursor: not-allowed !important;
        }
        /deep/ .el-select .el-input.is-disabled .el-input__suffix {
          color: #666 !important;
        }
      }
    }
    .element-list.is-disabled-wrap {
      border-color: #0090f0 !important;
      .left-item {
        opacity: 0.6;
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      .btn {
        width: 150px;
        border: 2px solid #0090f0;
        border-radius: 6px;
        height: 30px;
        line-height: 30px;
        margin: 0 10px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .element-list {
    border: 2px solid #0090f0;
    border-radius: 6px;
    height: 30px;
    line-height: 30px;
    margin: 10px 0;
    text-align: center;
  }
  .file-style-item1 {
    width: 150px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 2px solid #0090f0;
    border-radius: 6px;
    margin: 10px 0;
  }
  .upload-demo {
    width: 100%;
    .el-upload-list__item {
      width: 49%;
      float: left;
    }
  }
  .upload-demo /deep/ .el-icon-close {
    color: #0090f0;
  }
  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/redactModel/index.vue